import { put, take } from 'redux-saga/effects';

import { GO_TO_PAGE_FAIL } from 'PipeRouter';

import { SET_PAGE_BREAK_ERROR } from 'Reducers/dataModels';


function* goToPageFail() {
  while(true) {
    yield take(GO_TO_PAGE_FAIL);

    yield put({
      type: 'SET_PAGE_BREAK_ERROR',
      data: { message: 'Not a valid page number' }
    });
  }
}

export default goToPageFail;
